import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let ignore = false;
    api.get(`/blog/${slug}`)
      .then(({ data }) => { if (!ignore) setPost(data); })
      .catch(() => { if (!ignore) setNotFound(true); });
    return () => { ignore = true; };
  }, [slug]);

  const renderBody = () => {
    if (notFound) return <div className="mt-10">Post not found.</div>;
    if (!post) return <div className="mt-10 text-slate-500">Loading…</div>;
    return (
      <>
        <div className="mt-6 flex flex-wrap gap-1">
          {(post.tags || []).map((t) => (
            <Badge key={t} variant="secondary" className="text-[10px] uppercase tracking-wider">{t}</Badge>
          ))}
        </div>
        <h1 className="mt-4 font-[Chivo] text-4xl lg:text-5xl font-black text-[#0A2540] tracking-tight" data-testid="blog-post-title">{post.title}</h1>
        <div className="mt-4 text-xs text-slate-500 font-mono uppercase tracking-widest">By {post.author}</div>
        <p className="mt-8 text-lg text-slate-700 leading-relaxed">{post.excerpt}</p>
        <div className="mt-6 text-slate-700 leading-relaxed whitespace-pre-line">{post.body}</div>
      </>
    );
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <article className="mx-auto max-w-3xl px-6 lg:px-8 py-16 flex-1" data-testid="blog-article">
        <Link to="/blog" className="text-sm text-slate-500">← Back to all posts</Link>
        {renderBody()}
      </article>
      <Footer />
    </div>
  );
}
